import supabase from '@/api/supabase/index'

// Price alerts replace CheapShark's CORS-blocked /alert endpoint and are now
// backed entirely by Supabase — no NodeMailer confirmation email is sent from
// the browser. An alert row is persisted to `price_alerts` and the user's
// notification address is stored on their `user_profiles.alert_email`, so a
// server-side job has everything it needs to email the user when the price
// drops. Persisting requires an authenticated session (the UI wraps every
// entry point in AuthGuard); when signed out these are no-ops.
//
// The Supabase write helpers resolve with an { error } envelope instead of
// rejecting, so we inspect it and throw — otherwise a failed DB write would be
// reported to the user as success while the daily cron never sees the alert.
export async function setPriceAlert ({ currentUser, email, gameID, title, price }) {
  if (!currentUser) return

  // Persist the notification address first so a stored alert always has a
  // destination; throwing here means no alert row is created without an email.
  const { error: emailError } = await supabase.updateAlertEmail(currentUser.id, email)
  if (emailError) throw emailError

  const { error } = await supabase.upsertPriceAlert(currentUser.id, {
    gameID,
    title,
    targetPrice: price,
  })
  if (error) throw error
}

// Remove a previously-set alert from Supabase (no-op when signed out).
export async function cancelPriceAlert ({ currentUser, gameID }) {
  if (currentUser) {
    const { error } = await supabase.deletePriceAlert(currentUser.id, gameID)
    // Throw so the UI can't clear a still-active alert on a failed delete.
    if (error) throw error
  }
}
